/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { encodeBase64 } from '../../utils/utilityFunctions';
import { CALL_API } from '../middleware';
import {
  GenerateTokenWithRoleRequestBody,
  GenerateTokenWithRoleResponseBody,
  GetInvestorJointHolderDetailsRequestBody,
  GetInvestorJointHolderDetailsResponseBody,
  GetInvestorTokenCompanyRequestBody,
  GetInvestorTokenCompanyResponseBody,
  GetRoleBasedPermissionsRequestBody,
  GetRoleBasedPermissionsResponseBody,
  LoginWithOtpRequestBody,
  LoginWithOtpResponseBody,
  VerifyLoginEmailRequestBody,
  VerifyLoginEmailResponseBody,
  VerifyLoginOtpRequestBody,
  VerifyLoginOtpResponseBody,
} from '../types/api-types';
import {
  LOGIN_WITH_OTP,
  LOGIN_WITH_OTP_SUCCESS,
  LOGOUT_SUCCESS,
  VERIFY_LOGIN_OTP,
  VERIFY_LOGIN_OTP_SUCCESS,
  GET_USER_INFO_SUCCESS,
  GET_USER_INFO,
  SHOW_GLOBAL_ERROR,
  LOGOUT,
  GET_JOINT_ACCOUNT_LIST_SUCCESS,
  GET_JOINT_ACCOUNT_LIST_FAILED,
  NEW_VERIFY_LOGIN_OTP_SUCCESS,
  NEW_VERIFY_LOGIN_OTP,
  SET_CORRELATION_ID,
  GET_INVESTOR_JOINT_HOLDER_DETAILS_SUCCESS,
  GET_INVESTOR_JOINT_HOLDER_DETAILS,
  GET_INVESTOR_TOKEN_COMPANY,
  GET_INVESTOR_TOKEN_COMPANY_SUCCESS,
  GENERATE_TOKEN_WITH_ROLE_SUCCESS,
  GENERATE_TOKEN_WITH_ROLE,
  GET_ROLE_BASED_PERMISSIONS_SUCCESS,
  GET_ROLE_BASED_PERMISSIONS,
  VERIFY_LOGIN_EMAIL_SUCCESS,
  VERIFY_LOGIN_EMAIL,
} from '../types/auth';

export const loginWithOtp =
  (body: LoginWithOtpRequestBody) =>
    async (dispatch: any): Promise<LoginWithOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/users/login/send-otp`,
          method: 'POST',
          types: [LOGIN_WITH_OTP_SUCCESS, LOGIN_WITH_OTP],
          body: { payload: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const verifyLoginOtp =
  (body: VerifyLoginOtpRequestBody) =>
    async (dispatch: any): Promise<VerifyLoginOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/users/login/verify-otp`,
          method: 'POST',
          types: [VERIFY_LOGIN_OTP_SUCCESS, VERIFY_LOGIN_OTP],
          body: { payload: encodeBase64(JSON.stringify(body)) },
        },
      });
    };
export const newVerifyLoginOtp =
  (body: VerifyLoginOtpRequestBody) =>
    async (dispatch: any): Promise<VerifyLoginOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/users/login/verify-otp`,
          method: 'POST',
          types: [NEW_VERIFY_LOGIN_OTP_SUCCESS, NEW_VERIFY_LOGIN_OTP],
          body: { payload: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const logout = () => {
  return {
    [CALL_API]: {
      url: `/users/users/logout`,
      method: 'POST',
      types: [LOGOUT_SUCCESS, LOGOUT],
    },
  };
};

export const getUserInfo = () => {
  return {
    [CALL_API]: {
      url: `/users/users/me`,
      method: 'GET',
      types: [GET_USER_INFO_SUCCESS, GET_USER_INFO],
    },
  };
};

export const showError = (message: string) => {
  return {
    type: SHOW_GLOBAL_ERROR,
    errorType: 'ALERT',
    message,
  };
};

export const getJointAccountList = () => {
  return {
    [CALL_API]: {
      // url: `/users/users/account-list`,
      enableFixture: true,
      json: 'joint-account-list.json',
      method: 'GET',
      types: [GET_JOINT_ACCOUNT_LIST_SUCCESS, GET_JOINT_ACCOUNT_LIST_FAILED],
    }
  }
};

export const setCorrelationId = (correlationId: string | null) => {
  return {
    type: SET_CORRELATION_ID,
    correlationId,
  };
};

export const getInvestorJointHolderDetails =
  ({ temporaryToken, body }: GetInvestorJointHolderDetailsRequestBody) =>
    async (dispatch: any): Promise<GetInvestorJointHolderDetailsResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/dashboard/getInvestorDetails',
          method: 'POST',
          types: [GET_INVESTOR_JOINT_HOLDER_DETAILS_SUCCESS, GET_INVESTOR_JOINT_HOLDER_DETAILS],
          temporaryToken: temporaryToken ?? "",
          body
        },
      });
    };

export const getInvestorTokenCompany =
  (body: GetInvestorTokenCompanyRequestBody) =>
    async (dispatch: any): Promise<GetInvestorTokenCompanyResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/users/users/generate-investor-token-with-company',
          method: 'POST',
          types: [GET_INVESTOR_TOKEN_COMPANY_SUCCESS, GET_INVESTOR_TOKEN_COMPANY],
          temporaryToken: body?.temporaryToken ?? "",
          body: {
            clientCode: body?.clientCode,
            applicationId: body?.applicationId
          },
        },
      });
    };

export const generateTokenWithRole =
  (body: GenerateTokenWithRoleRequestBody) =>
    async (dispatch: any): Promise<GenerateTokenWithRoleResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/users/users/generate-token-with-role',
          method: 'POST',
          types: [GENERATE_TOKEN_WITH_ROLE_SUCCESS, GENERATE_TOKEN_WITH_ROLE],
          temporaryToken: body?.temporaryToken ?? "",
          body: {
            role: body?.role ?? ""
          },
        },
      });
    };

export const getRoleBasedPermissions =
  (body: GetRoleBasedPermissionsRequestBody) =>
    async (dispatch: any): Promise<GetRoleBasedPermissionsResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/amc/getRoleBasedPermissions',
          method: 'GET',
          types: [GET_ROLE_BASED_PERMISSIONS_SUCCESS, GET_ROLE_BASED_PERMISSIONS],
          temporaryToken: body?.temporaryToken ?? "",
        },
      });
    };

export const verifyLoginEmail =
  (body: VerifyLoginEmailRequestBody) =>
    async (dispatch: any): Promise<VerifyLoginEmailResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/users/login/verify-email',
          method: 'POST',
          types: [VERIFY_LOGIN_EMAIL_SUCCESS, VERIFY_LOGIN_EMAIL],
          body
        },
      });
    };

